import React, { useEffect, useState } from "react";
import styles from "./meetingsummary.module.scss";
import moment from "moment";
import { Dropdown, Form, Menu, Modal, Popover, Radio, Select, Switch, Tooltip } from "antd";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import store from "../../../../../context/store/store";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import { URInputwithLabel } from "../../../../../shared/widgets/inputwithLable";
import axios from "axios";
import { storeEditMOM, storeMOM } from "../../../../../base/meetingService/meetingStoreServices";
import {editSummary,searchHandler, searchMeetingHighlight} from "../../../../../base/callService/common";
import jsPDF from 'jspdf';
import _ from "lodash";
import Lottie from 'lottie-react';
import groovyWalkAnimation from "../../../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../../../styles/images/Lottie Animation.json";
import { useSelector } from "react-redux";
import { filesUploadApiSocket, generateChatID, userInfo } from "../../../../../base/socketChatService/utils";
import { LoginState } from "../../../../../models/model";
// import { config } from "unifiedring-sdk/dist/base/config";
import { config } from "../../../../../base/constant";
import { getCookie } from "../../../../../base/utils";
import { SocketChatService } from "../../../../../base/socketChatService";
import { uuidv4 } from "../../../../../base/meetingService/utils/meetingServices";
import ReactQuill from "react-quill";
import { URInput } from "../../../../../shared/widgets/input";
import MeetingHighlights from "../meetinghighlights";
const { Option } = Select;
// import { URCheckBox } from "../../../../shared/widgets/checkbox";

type MeetingStartScreenState = {
  download: any;
  allContacts: any;
  favouriteContacts: any;
  searchKey: string;
  shareUrl: string;
  shareContact: any;
  editModal: boolean;
  editedContent:any;
  partMOM:any;
};

export default function
  MeetingSummary() {
  let {  contactReducer }: any = useSelector((state: any) => state);

  let { workContacts, favContacts } = contactReducer;
  let { userdetails }: LoginState = store.getState().loginReducer;
  let { originalMOM, detailPage, momLoad, part_MOM,editMOM,editSummaryState,searchKey } = store.getState().meetingReducer;
  const [getData, setData] = useState<MeetingStartScreenState>({
    download: "", allContacts: workContacts, favouriteContacts: favContacts, searchKey: "", shareUrl: "", shareContact: [],editModal: false,editedContent:part_MOM,partMOM:part_MOM
  });   
  

  useEffect(()=>{
    setData({...getData,partMOM:part_MOM,searchKey:searchKey});
    var output = document.getElementById('para');
    if(output)
    {
      let escapedSearchKey :any= escapeRegExp(searchKey);
      var regex = new RegExp(escapedSearchKey, 'gi');
    var result = editMOM.replace(regex, '<span class="highlight1">$&</span>');
    output.innerHTML = result;}
    search(searchKey);
    },[part_MOM,searchKey]);
  
    function escapeRegExp(string:any) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
    }
  const fontSize = ["10px", "15px", "18px", "20px", "32px", "54px"]
  const modules = {
    toolbar: {

      container: [
        ["bold", "italic", "underline", "strike"],
        [{ 'size': [fontSize] }],
        [
          { list: "ordered" },
          { list: "bullet" },
          { align: "right" }
        ],
        ["link", "image"]
      ]
    },
    clipboard: { matchVisual: false }
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "size",
    "list",
    "bullet",
    "link",
    "image",
    "align",
    "color",
    "background"
  ];


  const edit = () => {
    setData({ ...getData, editModal: true })
  }

  const handleCancel = () => {
    setData({ ...getData, editModal: false })
  };

  const handleChange = _.debounce((content: any, delta: any, source: any, editor: any) => {
    const getHTML = editor.getHTML();

    let text = getHTML;
    text = text.replace(/<\/li>/gi, " || ");
    text = text.replace(/<[^>]+>/g, '');
    let strx = text.split('||');
    let array: any = [];
    strx.forEach(function (obj: any) {
      array.push({
        text: obj
      });
    });
    var last = array.slice(-1)[0];
    let editData = last.text.trim() === "" ? array.splice(0, array.length - 1) : array;
    console.log("editdata>>", editData);
    setData({...getData,editedContent:editData[0].text});

  }, 1000);


  const search = (data: any) => {
    if (data !== "") {
        let filtered = _.filter(part_MOM, function (elem: any) {
          // return elem.summary?.toLowerCase().includes(data.toLowerCase()) 
          if(data.toLowerCase().includes(elem.name.toLowerCase()) ){            
            return elem.summary;
          }
        });
        
        setData({ ...getData, partMOM: filtered });
    }
    else {
      setData({ ...getData, partMOM: part_MOM });
    }
  }

  const saveSummary=()=>{
    editSummary({edited_summary:getData.editedContent,edited_state:true});
    setData({ ...getData, editModal: false })
  }

  const switchOriginal=(e:any)=>{
    let{editMOMCopy}=store.getState().meetingReducer;
    
    if(e){storeEditMOM(originalMOM[0].summary,true);}
    else{
      storeEditMOM(editMOMCopy,true);
    }
  }



  let len = Math.round((part_MOM?.length / 8)) > 0 ? part_MOM?.length : 1;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();


  return (
    <>

      <div className={styles.tabsubinnerconsecmain}>
        <div className={styles.tabinnerbodyconsec}>
          
          {/* <div className={styles.headertopselectionsummery}> */}
            {/* <div className={styles.rightsidesec}>
              {!getData.editModal && <div> <URInput placeHolder="Search" className="leftbarsearch summarysearchbg" onChange={searchMOM} value={getData.searchKey} /></div>}
              <div> <p className={styles.editbadges}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={!getData.editModal ? 'Copy' : 'Save'}>
                  <span className={!getData.editModal ? "icon_copydoc" : "icon_ribbonfill"} onClick={!getData.editModal ? summaryCopy : handleCancel}></span>
                </Tooltip>
              </p></div>
              <div> <p className={styles.editbadges}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={!getData.editModal ? 'Edit' : 'Cancel'}>
                  <span className={!getData.editModal ? "icon_editfill" : "icon_close"} onClick={!getData.editModal ? edit : handleCancel}></span>
                </Tooltip>
              </p></div>
            </div> */}

          {/* </div> */}
          {/* <div className={styles.bordersert}></div> */}
          <div className={styles.summarydetailssec} id="summary">
            <div className={styles.summaryheadersec}>
              <div className={styles.topheadersec}>
                <div> <h4>
                  Overall Summary{userdetails?.sip_login_id === detailPage.sip_id  && editSummaryState && <label>(edited)</label>}{userdetails?.sip_login_id === detailPage.sip_id  && <span className="icon_editpen" onClick={edit}></span>}
                </h4></div>
                {userdetails?.sip_login_id === detailPage.sip_id && editSummaryState &&<div><p> <span>Show Original</span> <Switch onChange={switchOriginal}></Switch></p></div>}

              </div>


              {editMOM && <p  id="para">{editMOM}</p>}
            </div>
            <div className={styles.summarydetailinnermiddle}>
              <h4>Participant summary</h4>
              {getData.partMOM?.length > 0 && getData.partMOM.map((elem: any, index: any) => {
                      let searchh: any = searchMeetingHighlight(elem, getData.searchKey);
                return <div key={index} className={styles.middlemainconsec}>
                  <div className={styles.userprofilelfttxt}>
                    <div><URAvatarGroup className={`lefts size20  colorBG${random_color[index]}`}
                    profileInfo={<><span>{elem.name.toUpperCase().charAt(0)}</span></>} /></div>
                    <div><h4> {elem.name}</h4></div>
                  
                  </div>
                  {(searchh?.middleMsg !== "" && getData.searchKey !== "") ?
                          <p>{searchh?.firstMsg}
                            < span className={'highlight1'}>{searchh?.middleMsg}</span>{searchh?.lastMsg}</p> : (searchKey !== "" && searchh?.middleMsg === "") ?
                            <p>{elem.summary}</p> : <><p>{elem.summary}</p></>}
                </div>
              })}
            </div>
          </div>

          {
            (part_MOM?.length === 0) && !momLoad && <div className={styles.middlemainconsec}>
              <h4></h4>
              <p className={styles.nodatafound}>No Data Found</p>
            </div>
          }
          {
            part_MOM?.length === 0 && momLoad &&
            <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader} /></div>
          }
        </div>
      </div>
      <Modal title="Edit Summary"
          centered
          visible={getData.editModal}
          onCancel={handleCancel}
          onOk={saveSummary}
          cancelText="Cancel"
          okText="Save"
          width="493px"
          cancelButtonProps={{ className: 'urButton buttonWhite' }}
          okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup dateicon borderbtmset" >
          
          {editMOM &&
                <ReactQuill
                  placeholder={'Enter description'}
                  formats={formats}
                  modules={modules}
                  theme="snow"
                  readOnly={false}
                  onChange={(content: any, delta: any, source: any, editor: any) =>
                    handleChange(content, delta, source, editor)}
                >
                  <p>{editMOM}</p>

                </ReactQuill>}
          

        </Modal>

    </>
  );
};

